import React from 'react'
import { formatInTimeZone } from 'date-fns-tz'
import { Box, Flex, Text } from '@chakra-ui/react'

import {
    ChatFieldsFragment,
    PatientPimsReminderFieldsFragment,
} from '~graphql/generated/graphql'
import { navigate } from 'gatsby'
import { UserRoutes } from '~config/routes'

interface Props {
    chat: ChatFieldsFragment
    reminder: PatientPimsReminderFieldsFragment
}

export default function ClientReminderItem({ chat, reminder }: Props) {
    const { clinic } = chat

    const dueDate = reminder.display_due_date || reminder.send_date
    const reminderDueDate = formatInTimeZone(
        dueDate,
        clinic.time_zone || 'America/New_York',
        'PP',
    )

    function handlePatientClick() {
        navigate(
            UserRoutes.ChatConversation(chat.id) +
                `&patient=${reminder.patient?.id}`,
        )
    }

    return (
        <Flex
            rounded="xl"
            flexDir="row"
            alignItems="flex-start"
            justifyContent="space-between"
            w="full"
            _hover={{ bg: 'gray.50' }}
            p={3}
        >
            <Box>
                <Text fontSize="xs" fontWeight="medium">
                    {reminder.reminder_type?.display_name ||
                        reminder.reminder_type?.reminder_type_name ||
                        reminder.reminder_desc}
                </Text>
                {reminder.patient?.name && (
                    <Text
                        fontSize="11px"
                        color="gray.500"
                        _hover={{
                            textDecoration: 'underline',
                            cursor: 'pointer',
                        }}
                        onClick={handlePatientClick}
                    >
                        {reminder.patient?.name}
                    </Text>
                )}
            </Box>
            {dueDate ? (
                <Flex flexDir="column" alignItems="flex-end">
                    <Text fontSize="12px" color="gray.500">
                        Due
                    </Text>
                    <Text fontSize="xs" fontWeight="medium">
                        {reminderDueDate}
                    </Text>
                </Flex>
            ) : (
                <Text fontSize="12px" color="gray.500">
                    No due date
                </Text>
            )}
        </Flex>
    )
}
